import { ErrorCard, type ErrorCardProps } from '@eika/card';
import { RichIconTypes } from '@eika/rich-icon';
import { useTranslation } from '@translations';

interface AppErrorCardProps extends Omit<ErrorCardProps, 'title'> {
    title?: string;
}

export const AppErrorCard = (props: AppErrorCardProps) => {
    const { apiError, errors } = useTranslation();

    return (
        <ErrorCard
            title={errors.somethingWentWrong}
            errorCodeHeader={errors.errorCode}
            copyErrorCode={errors.copyErrorCode}
            icon={RichIconTypes.NETTVERKSBRUDD_HARE}
            informationModalProps={{
                title: apiError.informationModalTitle,
                description: apiError.informationModalDescription,
            }}
            {...props}
        />
    );
};
